export const ROUTE_PATH = '/stopes/*';
export const TITLE = 'Stopes';
